<template>
  <div class="mt-50">
    <b-alert
      v-if="!selectedOption && !loading && !hasSelectableOptions && options.length === 0"
      variant="warning"
      show
      class="p-50 text-center"
    >
      {{ $t('schedule.no-available-employee') }}
    </b-alert>

    <template v-else>
      <b-button
        v-if="selectedOption"
        variant="primary"
        size="sm"
        class="mr-50 mb-50"
        @click="handleClear"
      >
        <feather-icon
          icon="UserCheckIcon"
          size="14"
          class="mr-25"
        />
        {{ selectedOption.user.surname }} {{ selectedOption.user.name }}
        <feather-icon
          v-if="isFallbackOption(selectedOption)"
          v-b-tooltip.hover
          :title="$t('schedule.planner.fallback-no-availability-warning')"
          icon="AlertTriangleIcon"
          size="14"
          class="text-warning ml-25"
        />
      </b-button>

      <template v-if="!selectedOption">
        <template v-for="option in options">
          <b-button
            v-if="!option.shift"
            :key="`btn-option-${option.id}`"
            variant="outline-secondary"
            size="sm"
            class="mr-50 mb-50"
            @click="handleOptionClick(option)"
          >
            <feather-icon
              icon="UserPlusIcon"
              size="14"
              class="mr-25"
            />
            {{ option.user.surname }} {{ option.user.name }}
            <feather-icon
              v-if="isFallbackOption(option)"
              v-b-tooltip.hover
              :title="$t('schedule.planner.fallback-no-availability-warning')"
              icon="AlertTriangleIcon"
              size="14"
              class="text-warning ml-25"
            />
          </b-button>

          <b-button
            v-else
            :key="`btn-option-disabled-${option.id}`"
            variant="outline-secondary"
            size="sm"
            class="mr-50 mb-50"
            disabled
          >
            <feather-icon
              icon="UserIcon"
              size="14"
              class="mr-25"
            />
            {{ option.user.surname }} {{ option.user.name }}
          </b-button>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    selectedOption: {
      type: Object,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    hasSelectableOptions: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    function isFallbackOption(option) {
      return Boolean(
        option?.isFallbackWithoutAvailability
        || option?.isPlannedWithoutAvailability
        || option?.shift?.isPlannedWithoutAvailability,
      )
    }

    function handleClear() {
      emit('clear', props.selectedOption)
    }

    function handleOptionClick(option) {
      if (props.selectedOption) {
        emit('change', { from: props.selectedOption, to: option })
      } else {
        emit('select', option)
      }
    }

    return {
      isFallbackOption,
      handleClear,
      handleOptionClick,
    }
  },
}
</script>
